import { FC, Fragment, ReactNode } from 'react';
import { $Formutil, connect } from 'react-bootstrap-formutil';
import { FileInput, FileUploaderType } from 'components/Uploader';
import { PicProofEnum } from 'types/common';
import { printf } from 'utils/i18n';
import './style.scss';

// 修改资料证明类型(身份证件+居住地址)
type UpdateProofType = PicProofEnum.PIC_ID_CARD | PicProofEnum.PIC_ID_CARD2 | PicProofEnum.PIC_RESIDENCE;

export interface UpdateUploadProps {
    $formutil: $Formutil<Record<UpdateProofType, string>>;
    type: UpdateProofType;
    desc?: ReactNode;
    showTips?: boolean;
}

const tips: string[] = [
    __('请确保照片边框完整、文字清晰、无反光。'),
    __('请确保照片未过期，且与账户持有人一致。'),
    __('请使用证件原件拍照。老虎证券将对您的身份信息进行加密，仅用于账户审核。'),
    __('如果点击上传没有反应，请先确认是否开启拍照权限。')
];

const updateUploadConfig: Record<
    UpdateProofType,
    {
        name: string;
        fileList: PicProofEnum[];
        types?: FileUploaderType[];
        tooltips?: string[];
    }
> = {
    [PicProofEnum.PIC_ID_CARD]: {
        name: __('ssn'),
        fileList: [PicProofEnum.PIC_ID_CARD],
        types: [PicProofEnum.PIC_ID_CARD]
    },
    [PicProofEnum.PIC_ID_CARD2]: {
        name: __('identification documents'),
        fileList: [PicProofEnum.PIC_ID_CARD2],
        types: ['pic_common_id_card']
    },
    [PicProofEnum.PIC_RESIDENCE]: {
        name: __('residential address'),
        fileList: [PicProofEnum.PIC_RESIDENCE],
        types: [PicProofEnum.PIC_RESIDENCE],
        tooltips: [__('请上传地址证明')]
    }
};

/**
 * @description 修改资料上传图片证明
 */
const UpdateUpload: FC<UpdateUploadProps> = ({ desc, type, showTips }) => {
    const { name, fileList, types = [], tooltips = [] } = updateUploadConfig[type];

    return (
        <div className="update-upload-root">
            {desc && <div className="desc mb-2">{desc}</div>}
            {showTips &&
                tips.map((tip, index) => (
                    <div className="label-desc" key={index}>
                        <p className="desc-item">{`${index + 1}.${tip}`}</p>
                    </div>
                ))}
            <div className="file-wrapper">
                {fileList?.map((file, index) => (
                    <Fragment key={file}>
                        <FileInput
                            required
                            name={file}
                            length={fileList.length}
                            $parser={value => value?.url}
                            type={types[index]}
                            tooltip={tooltips[index]}
                            $validators={{
                                required: value => !!value || printf(__('Upload proof of %s'), name)
                            }}
                        />
                    </Fragment>
                ))}
            </div>
        </div>
    );
};

export default connect(UpdateUpload);
